// ErrorMessage.js
import React from 'react';

const ErrorMessage = ({ message }) => {
  return (
    <div className="error-message">
      <div className="error-icon">⚠️</div>
      <p>{message || 'An error occurred. Please try again.'}</p>
    </div>
  );
};

export default ErrorMessage;